import FullWidthLayout from '@/layouts/FullWidthLayout.vue';

const routes = [
  {
    path: '/',
    name: 'JobList',
    meta: {
      requiresAuth: true,
      title: 'Jobs List',
      layout: FullWidthLayout
    },
    component: () => import('@/views/JobList.vue')
  },
  {
    path: '/canceled',
    name: 'CanceledJobs',
    meta: {
      requiresAuth: true,
      title: 'Canceled Jobs',
      layout: FullWidthLayout
    },
    component: () => import('@/views/CanceledJobList.vue')
  },
  {
    path: '/code/:jobShortCode',
    name: 'JobShortCodeRedirect',
    meta: { requiresAuth: true, layout: FullWidthLayout },
    component: () => import('@/components/JobShortCodeRedirect.vue')
  },
  {
    path: '/create',
    name: 'JobCreate',
    meta: {
      requiresAuth: true,
      layout: FullWidthLayout,
      title: 'Create Job'
    },
    component: () => import('@/views/JobCreate.vue')
  },
  {
    path: '/quick-quote',
    name: 'QuickQuote',
    meta: {
      requiresAuth: true,
      layout: FullWidthLayout,
      title: 'Quick Quote'
    },
    component: () => import('@/views/QuickQuote.vue')
  },
  {
    path: '/:jobId([a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12})',
    name: 'JobDetail',
    meta: {
      requiresAuth: true,
      isInternal: false,
      layout: FullWidthLayout
    },
    component: () => import('@/views/JobDetail.vue')
  }
];

export default routes;
